export default __webpack_public_path__ + "static/media/seating.ad74af2b.jpg";